export const facebookId = '124855947871355';

export const twitterUser = '@SpaindeVere';

export const shareaholic = {
	news: '33139422',
	event: '33139424'
};

export const locale = 'en-ES'; // 'en-ZM'
export const dateFormat = 'dd.MM.YYYY';

// Mobile, Tablet, everything except Desktop
export const deviceSize = 992; // 1200;

export const TTL = 1800; // 30 mins
